import { cva } from 'class-variance-authority'

const popupVariants = cva(
  // Base — desktop centring + mobile fullscreen reset baked in. `overflow-hidden` keeps the body's
  // scroll area inside the rounded corners; the desktop max-height is what lets it scroll at all.
  `
    fixed top-1/2 left-1/2 z-50 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-30 border
    border-line-base-main bg-surface-base-normal shadow-bottom-30 outline-none
    data-[closed]:animate-out data-[closed]:motion-exit data-[closed]:fade-out-0 data-[closed]:fill-mode-forwards
    data-[closed]:zoom-out-95
    data-[open]:animate-in data-[open]:motion-enter data-[open]:fade-in-0 data-[open]:zoom-in-95
    max-md:inset-0 max-md:top-0 max-md:left-0 max-md:h-dvh max-md:w-screen max-md:max-w-none max-md:translate-x-0
    max-md:translate-y-0 max-md:rounded-none
    md:max-h-[calc(100dvh-2*var(--spacing-70))]
  `,
  {
    variants: {
      size: {
        small: 'md:max-w-[384px]',
        medium: 'md:max-w-[576px]',
        large: 'md:max-w-[768px]',
        xlarge: 'md:max-h-[calc(100dvh-2*var(--spacing-30))] md:max-w-[calc(100vw-2*var(--spacing-30))]',
      },
    },
    defaultVariants: { size: 'medium' },
  },
)

export { popupVariants }
